import cn from 'classnames'

import css from './OrderedList.module.css'

type OrderedListProps = {
    children: React.ReactNode
    className?: string
}

export default function OrderedList({ children, className = '' }: OrderedListProps) {
    return <ol className={cn(css.orderedList, className)}>{children}</ol>
}
